import {Box, Button, Input, Typography} from '@viptech/react-components'
import {useState} from 'react'
import {InfoFacialRecognition} from 'src/common/components/register-facial-recognition/components/info-facial-recognition/InfoFacialRecognition'
import {UploadPhotos} from 'src/common/components/register-facial-recognition/components/upload-photos/UploadPhotos'
import ModalLateral, {ModalLateralFooter} from 'src/components/modal/ModalLateral'
import useCreateFace from 'src/hooks/api/facial/useCreateFace'
import createStyleSheet from 'src/utilities/createStyleSheet'

type CreateFaceModalProps = {
  isOpen: boolean
  closeModal: (shouldUpdateTable: boolean) => void
  listId: number
}

function CreateFaceModal(props: CreateFaceModalProps) {
  const {isOpen, closeModal, listId} = props
  const [name, setName] = useState('')
  const [images, setImages] = useState<Array<File> | null>([])
  const {mutateAsync, isPending: isLoading} = useCreateFace()

  function handleClose(shouldUpdateTable: boolean) {
    setName('')
    closeModal(shouldUpdateTable)
  }

  async function handleSaveList() {
    if (!images) return
    await mutateAsync({name, images: images, listsIds: [listId]})
    handleClose(true)
  }

  return (
    <ModalLateral isOpen={isOpen} closeModal={() => handleClose(false)} title='Novo Cadastro'>
      <Box height='92%' display='flex' direction='column' justifyContent='space-between' style={styles.overflow} maxHeight='86vh'>
        <Box display='flex' rowGap='32px' direction='column'>
          <Box width='100%' display='flex' direction='column' justify='center' align='center' rowGap='30px' marginTop='12px'>
            <Input.Root
              labelFontSize='14px'
              borderColor='#D0D5DD'
              fontSize='12px'
              labelFontWeight='400'
              label='Nome completo'
              maxLength={99}
              value={name}
              min={4}
              onChange={(e) => setName(e.target.value)}
            />

            <Box display='flex' direction='column' align='center' rowGap='32px' width='100%'>
              <Box display='flex' alignSelf='flex-start'>
                <Typography variant='p' color='#1A1A1A' size='16px'>
                  Selecione até dez fotos para o reconhecimento facial
                </Typography>
              </Box>
              <UploadPhotos handleFiles={setImages} />
            </Box>
          </Box>
          <InfoFacialRecognition />
          <Box padding='0 20px'>
            <Typography variant='p' color='#8E8E8E' size='10px'>
              Os requisitos da foto de rosto devem seguir as seguintes regras: Deve ser tirada em visão completa, de frente para a câmera. Não use chapéu ou
              cobertura para a cabeça ao tirar a foto do rosto. O formato deve ser JPEG ou JPG. A resolução deve ser de 150 × 300 pixels ou mais. O tamanho da
              imagem deve ser entre 10 KB e 300 KB.
            </Typography>
          </Box>
        </Box>
        <ModalLateralFooter>
          <Box display='flex' columnGap='12px' justify='flex-end' padding='0 40px'>
            <Button
              fontSize='12px'
              height='38px'
              width='120px'
              variant='outlined'
              color='#8E8E8E'
              disabled={isLoading}
              onClick={() => !isLoading && handleClose(false)}>
              Cancelar
            </Button>
            <Button
              fontSize='12px'
              height='38px'
              width='120px'
              disabled={!name || !images?.length}
              disabledTextColor='#8E8E8E'
              onClick={() => !isLoading && handleSaveList()}
              isLoading={isLoading}>
              Salvar
            </Button>
          </Box>
        </ModalLateralFooter>
      </Box>
    </ModalLateral>
  )
}

export default CreateFaceModal

const styles = createStyleSheet({
  overflow: {
    paddingRight: 6,
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarWidth: 'thin',
    '-ms-overflow-style': 'none',
  },
})
